import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import { message } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import RefreshGrid from "../../../utils/refreshGrid";
import { electricalLoss, getCityList, prefixFile } from "../../../fetch/fetchApi";

class ElectricalLoss extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      formConfig: null,
      visible: false,
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  // 页面加载完成，调用，初始化表格与form表单
  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.init();
  }

  // 页面初始化方法，初始化表格数据
  componentDidMount() {
    let defaultParam = {
      date: `${moment(new Date()).subtract(1, "d").format("YYYY-MM-DD")},${moment(new Date())
        .subtract(1, "d")
        .format("YYYY-MM-DD")}`,
    };
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      const date = window.LayoutTab.tabParam.date;
      defaultParam = {
        ...defaultParam,
        ...window.LayoutTab.tabParam,
        date: `${date[0].format("YYYY-MM-DD")},${date[1].format("YYYY-MM-DD")}`,
      };
    }
    this.fetchApi(defaultParam);
  }

  // 配置查询form表单方法
  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: "请输入电站名称",
          param: {
            name: "stubGroupName",
            type: "string",
          },
          labelName: "电站名称:",
          required: false,
          defaultValue: (window.LayoutTab && window.LayoutTab.tabParam && window.LayoutTab.tabParam.stubGroupName) ? window.LayoutTab.tabParam.stubGroupName : '',
        },
        {
          type: "input",
          placeholder: "请输入配电柜编号",
          param: {
            name: "meterId",
            type: "string",
          },
          labelName: "配电柜编号",
          required: false,
        },
        {
          type: "input",
          placeholder: "请输入电表编号",
          param: {
            name: "meterModuleId",
            type: "string",
          },
          labelName: "电表编号",
          required: false,
        },
        {
          type: "date",
          dateType: "rangeDate",
          placeholder: ["年/月/日", "年/月/日"],
          width: "200px",
          param: {
            name: "date",
            type: "array",
          },
          defaultValue:
            window.LayoutTab && window.LayoutTab.tabParam && window.LayoutTab.tabParam.date
              ? window.LayoutTab.tabParam.date
              : [moment(new Date()).subtract(1, "d"), moment(new Date()).subtract(1, "d")],
          validator: {
            // 自定义校验对象
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            // max_val: 7 // 可选最大天数
          },
          allowClear: false,
          labelName: "日期:",
          required: true,
        },
        {
          type: "areaPicker",
          isPickArea: !0,
          placeholder: "请选择地区",
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
          pickOnSelect: true,
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          required: !1,
          labelName: "地区",
          className: "allshow",
          sourceApi: getCityList,
        },
        //-------------
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "input",
              placeholder: "最小值",
              inputType: "number",
              width: "95px",
              param: {
                name: "actualLossPowerMin",
                type: "string",
              },
              labelName: "电损电量范围",
              required: false,
              validator: {
                // 自定义校验对象
                vtype: "numVal", // 校验名称
                max_point: 2, // 小数点位数
                // min_val: 0, // 可输入最小值
                // max_val: 9999 // 可输入最大值
              },
            },
            {
              type: "input",
              placeholder: "最大值",
              inputType: "number",
              width: "95px",
              param: {
                name: "actualLossPowerMax",
                type: "string",
              },
              required: false,
              validator: {
                // 自定义校验对象
                vtype: "numVal", // 校验名称
                max_point: 2, // 小数点位数
                // min_val: 0, // 可输入最小值
                // max_val: 9999 // 可输入最大值
              },
            },
          ],
        },

        //----------------
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "input",
              placeholder: "最小值(%)",
              inputType: "number",
              width: "95px",
              param: {
                name: "actualLossPowerRateMin",
                type: "string",
              },
              labelName: "运行电损率",
              required: false,
              validator: {
                // 自定义校验对象
                vtype: "numVal", // 校验名称
                max_point: 2, // 小数点位数
                // min_val: 0, // 可输入最小值
                // max_val: 9999 // 可输入最大值
              },
            },
            {
              type: "input",
              placeholder: "最大值(%)",
              inputType: "number",
              width: "95px",
              param: {
                name: "actualLossPowerRateMax",
                type: "string",
              },
              required: false,
              validator: {
                // 自定义校验对象
                vtype: "numVal", // 校验名称
                max_point: 2, // 小数点位数
                // min_val: 0, // 可输入最小值
                // max_val: 9999 // 可输入最大值
              },
            },
          ],
        },

        //-------------------
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "input",
              placeholder: "最小值",
              inputType: "number",
              width: "95px",
              param: {
                name: "powerDeviationMin",
                type: "string",
              },
              labelName: "电损电量偏差范围",
              required: false,
              validator: {
                // 自定义校验对象
                vtype: "numVal", // 校验名称
                max_point: 2, // 小数点位数
                // min_val: 0, // 可输入最小值
                // max_val: 9999 // 可输入最大值
              },
            },
            {
              type: "input",
              placeholder: "最大值",
              inputType: "number",
              width: "95px",
              param: {
                name: "powerDeviationMax",
                type: "string",
              },
              required: false,
              validator: {
                // 自定义校验对象
                vtype: "numVal", // 校验名称
                max_point: 2, // 小数点位数
                // min_val: 0, // 可输入最小值
                // max_val: 9999 // 可输入最大值
              },
            },
          ],
        },

        //-------------------
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "input",
              placeholder: "最小值(%)",
              inputType: "number",
              width: "95px",
              param: {
                name: "lossPowerRateDeviationMin",
                type: "string",
              },
              labelName: "电损率偏差范围",
              required: false,
              validator: {
                // 自定义校验对象
                vtype: "numVal", // 校验名称
                max_point: 2, // 小数点位数
                // min_val: 0, // 可输入最小值
                // max_val: 9999 // 可输入最大值
              },
            },
            {
              type: "input",
              placeholder: "最大值(%)",
              inputType: "number",
              width: "95px",
              param: {
                name: "lossPowerRateDeviationMax",
                type: "string",
              },
              required: false,
              validator: {
                // 自定义校验对象
                vtype: "numVal", // 校验名称
                max_point: 2, // 小数点位数
                // min_val: 0, // 可输入最小值
                // max_val: 9999 // 可输入最大值
              },
            },
          ],
        },

        //-------------------
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              icon: "search",
              text: "查询",
            },

            {
              btnType: "button",
              icon: "export",
              text: "导出",
              handler: (e, param) => {
                console.log(this);
                /**
                 * 数据导出方法
                 */
                const data = param.date ? [param.date.split(",")[0], param.date.split(",")[1]] : ["", ""];
                if (data[0] === "" || data[1] === "") {
                  message.error("请选择导出日期");
                  return;
                }
                const exportparam = {
                  stubGroupName: param.stubGroupName ? param.stubGroupName : "",
                  meterId: param.meterId ? param.meterId : "",
                  startTime: data[0],
                  endTime: data[1],
                  cityId: param.cityId ? param.cityId : "",
                  actualLossPowerMin: param.actualLossPowerMin ? param.actualLossPowerMin : "",
                  actualLossPowerMax: param.actualLossPowerMax ? param.actualLossPowerMax : "",
                  actualLossPowerRateMin: param.actualLossPowerRateMin ? param.actualLossPowerRateMin : "",
                  actualLossPowerRateMax: param.actualLossPowerRateMax ? param.actualLossPowerRateMax : "",
                  powerDeviationMin: param.powerDeviationMin ? param.powerDeviationMin : "",
                  powerDeviationMax: param.powerDeviationMax ? param.powerDeviationMax : "",
                  lossPowerRateDeviationMin: param.lossPowerRateDeviationMin ? param.lossPowerRateDeviationMin : "",
                  lossPowerRateDeviationMax: param.lossPowerRateDeviationMax ? param.lossPowerRateDeviationMax : "",
                };

                const selectCity = (param.cityId && param.cityId.split(",")) || [];
                switch (selectCity.length) {
                  case 1:
                    exportparam.cityId = selectCity[0];
                    break;
                  case 2:
                    exportparam.cityId = selectCity[1];
                    break;
                  case 3:
                    exportparam.cityId = selectCity[2];
                    break;
                  default:
                    exportparam.cityId = "";
                    break;
                }

                this.exportData(exportparam);
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {},
      tableKey: "electricalLossTable",
      tablePage: "电损",
    };
    return formConfig;
  };

  /**
   *
   * 表格单元格设置
   */
  init() {
    this.setState({
      tableConfig: {
        tableKey: "electricalLossTable",
        tableColumns: [
          {
            name: "配电柜编号",
            key: "meterId",
            colType: "textCol",
            align: "left",
          },
          {
            name: "电表编号",
            key: "meterModuleId",
            colType: "textCol",
            align: "left",
            render: (text) => (text || "--"),
          },
          {
            name: "地区",
            key: "cityName",
            colType: "textCol",
            align: "left",
          },
          {
            name: "电站",
            key: "stubGroupName",
            colType: "tipCol",
            align: "left",
            render: (value) => {
              if (value) {
                return value;
              } else {
                return "--";
              }
            },
          },
          {
            name: "直流数(设备)",
            key: "dcCnt",
            colType: "textCol",
            align: "center",
          },
          {
            name: "交流数(设备)",
            key: "acCnt",
            colType: "textCol",
            align: "center",
          },
          {
            name: "交直流数(设备)",
            key: "acdcCnt",
            colType: "textCol",
            align: "center",
          },
          {
            name: "日期",
            key: "date",
            colType: "textCol",
            align: "left",
            render: (value) => {
              return moment(value).format("YYYY-MM-DD");
            },
          },
          {
            name: "开始上报时间",
            key: "startReportTimeShow",
            colType: "textCol",
            align: "left",
          },
          {
            name: "最后上报时间",
            key: "endReportTimeShow",
            colType: "textCol",
            align: "left",
          },
          {
            name: "上报次数",
            key: "reportCnt",
            colType: "textCol",
            align: "center",
          },
          {
            name: "电表电量(kW·h)",
            key: "meterPower",
            colType: "textCol",
            align: "center",
          },
          {
            name: "总订单电量(kW·h)",
            key: "orderPower",
            colType: "textCol",
            align: "center",
          },
          {
            name: "交流电量(kW·h)",
            key: "acPower",
            colType: "textCol",
            align: "center",
          },
          {
            name: "直流电量(kW·h)",
            key: "dcPower",
            colType: "textCol",
            align: "center",
          },
          {
            name: "实际电损(kW·h)",
            key: "actualLossPower",
            colType: "textCol",
            align: "center",
            message: "实际电损=电表电量-总订单电量",
          },
          {
            name: "理论电损(kW·h)",
            key: "theoryLossPower",
            colType: "textCol",
            align: "center",
            message: "理论电损=工作电损+待机电损",
          },
          {
            name: "工作电损(kW·h)",
            key: "theoryWorkLossPower",
            colType: "textCol",
            align: "center",
            message: "该电表模块名下所有设备的工作电损相加，单桩工作电损=充电电量*(1-充电效率)/充电效率",
          },
          {
            name: "待机电损(kW·h)",
            key: "theoryAwaitLossPower",
            colType: "textCol",
            align: "center",
            message: "该电表模块名下所有设备的待机电损相加，单桩待机电损=待机功率*待机小时(按24h处理)",
          },
          {
            name: "电损偏差值(kW·h)",
            key: "powerDeviation",
            colType: "textCol",
            align: "center",
            message: "电损偏差值=实际电损-理论电损",
          },
          {
            name: "运行电损率(%)",
            key: "actualLossPowerRate",
            colType: "textCol",
            align: "center",
            message: "运行电损率=电损电量/电表电量*100%",
            render: (value) => {
              return value;
            },
          },
          {
            name: "理论电损率(%)",
            key: "theoryLossPowerRate",
            colType: "textCol",
            align: "center",
            message: "理论电损率=理论电损/(理论电损+总订单电量)*100%",
            render: (value) => {
              return value;
            },
          },
          {
            name: "电损率偏差值(%)",
            key: "lossPowerRateDeviation",
            colType: "textCol",
            align: "center",
            message: "电损率偏差值=运行电损率-理论电损率",
            render: (value) => {
              return value;
            },
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: electricalLoss,
        autoRefresh: false, // 设置为true 直接加载grid数据
      },
    });
  }

  /**
   *
   * 表格获取数据前数据格式调整方法，调整后通过组件获取表格数据
   */
  fetchApi = (param) => {
    const newParam = param;

    const selectCity = (param.cityId && param.cityId.split(",")) || [];
    switch (selectCity.length) {
      case 1:
        newParam.cityId = selectCity[0];
        break;
      case 2:
        newParam.cityId = selectCity[1];
        break;
      case 3:
        newParam.cityId = selectCity[2];
        break;
      default:
        newParam.cityId = "";
        break;
    }

    const data = param.date ? [param.date.split(",")[0], param.date.split(",")[1]] : ["", ""];

    newParam.startTime = data[0];
    newParam.endTime = data[1];
    delete newParam.date;

    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(param);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "electricalLossTable", newParam);
    }
  }

  // 数据导出
  exportData(param) {
    const excelUrl = `${prefixFile}/exportElectricalLossList.do`; // 配置导出地址
    const params = `stubGroupName=${
      param.stubGroupName
    }&meterId=${
      param.meterId
    }&startTime=${
      param.startTime
    }&endTime=${
      param.endTime
    }&cityId=${
      param.cityId
    }&actualLossPowerMin=${
      param.actualLossPowerMin
    }&actualLossPowerMax=${
      param.actualLossPowerMax
    }&actualLossPowerRateMin=${
      param.actualLossPowerRateMin
    }&actualLossPowerRateMax=${
      param.actualLossPowerRateMax
    }&powerDeviationMin=${
      param.powerDeviationMin
    }&powerDeviationMax=${
      param.powerDeviationMax
    }&lossPowerRateDeviationMin=${
      param.lossPowerRateDeviationMin
    }&lossPowerRateDeviationMax=${
      param.lossPowerRateDeviationMax
    }&local=zh`; // 配置参数
    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${params}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${params}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  }

  render() {
    const Content = (
      <div className='sc-page-content electrical-loss-page'>
        <div className='page-toolbar'>
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className='page-panel'>
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </div>
    );

    return Content;
  }
}

export default ElectricalLoss;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/electricalLoss/electricalLoss.js